import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "right",
      "label-col": {
        span: 6
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("审核流名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("审核流名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("标识")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("标识"),
      allowClear: ""
    },
    model: {
      value: _vm.form.mark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mark", $$v);
      },
      expression: "form.mark"
    }
  }, _vm._l(_vm.markList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("状态")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("已启用")))]), _c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("已禁用")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("类型"),
      allowClear: ""
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, _vm._l(_vm.typeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("归属客户")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("归属客户"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      change: _vm.applicationFun
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("应用")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("应用"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.form.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "applicationId", $$v);
      },
      expression: "form.applicationId"
    }
  }, _vm._l(_vm.applicationList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.applicationId
      }
    }, [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ")")]);
  }), 1)], 1)], 1)], 1), _c("div", {
    staticClass: "marginT10"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _vm.isAuth("home.auditStore") ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("新增")))]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "markName",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("home.flowNodeList") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "homeAuditSet",
                params: {
                  id: record.id
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("设置")))]) : _vm._e(), _vm.isAuth("home.auditEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("home.auditDelete") ? _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.auditShow ? _c("audit-model", {
    ref: "auditFrom",
    on: {
      cancel: function ($event) {
        _vm.auditShow = false;
      },
      ok: _vm.searchFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };